import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome'
import './NavHorizontal.css'
export interface INavMenuProps {
  current: string
}
const NavMenu = (props: INavMenuProps) => {
  const [cssBookmarksClass, setSssBookmarksClass] = useState<string>()
  const [cssProfileClass, setCssProfileClass] = useState<string>()
  const [cssEnquiryClass, setCssEnquiryClass] = useState<string>()
  const [cssResourcesClass, setCssResourcesClass] = useState<string>()
  const [cssHomeClass, setCssHomeClass] = useState<string>()

  useEffect(() => {
    if (props.current.includes('/my-account')) {
      setCssHomeClass('active permahover')
    }
  }, [props.current])
  useEffect(() => {
    if (props.current.includes('/my-account/resources')) {
      setCssResourcesClass('active permahover')
      setCssHomeClass('')
    }
  }, [props.current])

  useEffect(() => {
    if (props.current.includes('/my-account/profile')) {
      setCssProfileClass('active permahover')
      setCssHomeClass('')
    }
  }, [props.current])

  useEffect(() => {
    if (
      props.current.includes('/my-account/bookmarked-pages') ||
      props.current.includes('/my-account/bookmarked-results') ||
      props.current.includes('/my-account/bookmarked-awards') ||
      props.current.includes('/my-account/bookmarks')
    ) {
      setSssBookmarksClass('active permahover')
      setCssHomeClass('')
    }
  }, [props.current])
  useEffect(() => {
    if (
      props.current.includes('/my-account/enquiries') ||
      props.current.includes('/my-account/enquiry/submit-a-new-enquiry') ||
      props.current.includes('/my-account/enquiry')
    ) {
      setCssEnquiryClass('active permahover')
      setCssHomeClass('')
    }
  }, [props.current])

  return (
    <>
      <div>
        <nav className="horizontal">
          <NavLink
            to="/my-account"
            exact
            aria-label="Home"
            className={cssHomeClass}
          >
            <FontAwesomeIcon className="homeIcon" icon={faHome} size="2x" />
          </NavLink>
          <NavLink to="/my-account/enquiries" className={cssEnquiryClass}>
            Enquiries
          </NavLink>
          <NavLink to="/my-account/resources" className={cssResourcesClass}>
            Resources
          </NavLink>
          <NavLink to="/my-account/bookmarks" className={cssBookmarksClass}>
            Bookmarks
          </NavLink>
          <NavLink to="/my-account/profile" className={cssProfileClass}>
            Profile
            {/* <ul >
                <li>
                  <a href="/my-account/">Change MFA</a>
                </li>
                <li>
                  <a href="/my-account/my-enquiries">Change password</a>
                </li>
                </ul> */}
          </NavLink>
        </nav>
      </div>
    </>
  )
}

export default NavMenu
